import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text, IconButton, Tooltip } from './common';
import SvgIcon from './SvgIcon';

const Wrapper = styled(Box)`
  height: 48px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
  &:last-child {
    box-shadow: none;
  }
  cursor: ${props => (props.onClick && !props.disabled ? 'pointer' : 'auto')};
`;

function TableCell(props) {
  const {
    disabled = false,
    leftIcon,
    leftIconColor,
    rightIcons,
    rightIconColor,
    rightText,
    title,
    renderAccessories,
    onClick,
    iconTooltips,
    rightWeighted,
    rightTextStyle,
    ...restProps
  } = props;

  const iconProps = {
    width: 16,
    height: 16
  };

  const allTooltips = iconTooltips || {};
  const leftIconTooltip = leftIcon ? allTooltips[leftIcon] : '';

  return (
    <Wrapper
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      onClick={onClick && !disabled ? onClick : undefined}
      disabled={disabled}
      {...restProps}
    >
      <Box
        flex={rightWeighted ? 'unset' : 1}
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
      >
        {leftIcon && (
          <Box
            mr={4}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {!leftIconTooltip ? (
              <SvgIcon {...iconProps} name={leftIcon} color={leftIconColor} />
            ) : (
              <Tooltip
                animation="scale"
                delay={[300, 0]}
                duration={300}
                content={leftIconTooltip}
                theme="light-border"
                placement="bottom"
              >
                <span>
                  <SvgIcon
                    {...iconProps}
                    name={leftIcon}
                    color={leftIconColor}
                  />
                </span>
              </Tooltip>
            )}
          </Box>
        )}
        {title && <Text>{title}</Text>}
      </Box>
      <Box
        key={name}
        display="flex"
        cflexDirection="row"
        justifyContent="flex-end"
        alignItems="center"
        flex={rightWeighted ? 1 : 'unset'}
      >
        {rightIcons &&
          rightIcons.map(name => {
            const iconTooltip = allTooltips[name];
            return !iconTooltip ? (
              <SvgIcon
                mr={1}
                key={name}
                name={name}
                {...iconProps}
                color={rightIconColor}
              />
            ) : (
              <Tooltip
                key={name}
                animation="scale"
                delay={[300, 0]}
                duration={300}
                content={iconTooltip}
                theme="light-border"
                placement="bottom"
              >
                <span>
                  <SvgIcon
                    mr={1}
                    name={name}
                    {...iconProps}
                    color={rightIconColor}
                  />
                </span>
              </Tooltip>
            );
          })}
        {rightText && <Text style={rightTextStyle}>{rightText}</Text>}
        {renderAccessories && renderAccessories()}
        {onClick && !disabled && (
          <IconButton
            ml={1}
            onClick={() => {}}
            name="forward"
            width={12}
            height={12}
          />
        )}
      </Box>
    </Wrapper>
  );
}

TableCell.propTypes = {
  disabled: PropTypes.bool,
  leftIcon: PropTypes.string,
  rightIcons: PropTypes.array,
  title: PropTypes.string,
  rightText: PropTypes.any,
  selected: PropTypes.bool,
  size: PropTypes.string,
  renderAccessories: PropTypes.func,
  onClick: PropTypes.func,
  leftIconColor: PropTypes.string,
  rightIconColor: PropTypes.string,
  iconTooltips: PropTypes.object,
  rightTextStyle: PropTypes.any,
  rightWeighted: PropTypes.bool
};

TableCell.defaultProps = {
  bg: 'transparent',
  pl: 0,
  pr: 3,
  ml: 3
};

export default TableCell;
